<template>
  <fragment>
    <div class="body-wrapper-inner">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">
            <div class="d-sm-flex gap-1 align-items-center mb-4">
              <h5 class="card-title fw-semibold mb-3 mb-sm-0 me-auto">Pengaturan Umum</h5>
            </div>
            <hr class="border-0 bg-primary pt-1 rounded my-4">

            <div class="row g-4">
              <div class="col-sm-7 col-lg-8 order-2 order-sm-1">
                <form @submit.prevent="onSubmit">
                  <div class="row g-0 g-lg-3 align-items-center mb-3">
                    <div class="col-lg-4">
                      <label for class="col-form-label">Nama Aplikasi *</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="text"
                        v-model="form.site_title"
                        class="form-control"
                        value
                        placeholder="Nama Aplikasi..."
                        autocomplete="off"
                      >
                    </div>
                  </div>
                  <div class="row g-0 g-lg-3 align-items-center mb-3">
                    <div class="col-lg-4">
                      <label for class="col-form-label">Deskripsi</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="text"
                        v-model="form.site_description"
                        class="form-control"
                        value
                        placeholder="Deskripsi..."
                        autocomplete="off"
                      >
                    </div>
                  </div>

                  <hr class="border-0 pt-1 bg-dark rounded my-4">

                  <div class="row g-0 g-lg-3 align-items-center mb-3">
                    <div class="col-lg-4">
                      <label for class="col-form-label">Alamat</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="text"
                        v-model="form.address"
                        class="form-control"
                        value
                        placeholder="Alamat..."
                        autocomplete="off"
                      >
                    </div>
                  </div>
                  <div class="row g-0 g-lg-3 align-items-center mb-3">
                    <div class="col-lg-4">
                      <label for class="col-form-label">Kota</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="text"
                        v-model="form.city"
                        class="form-control"
                        value
                        placeholder="Kota..."
                        autocomplete="off"
                      >
                    </div>
                  </div>
                  <div class="row g-0 g-lg-3 align-items-center mb-3">
                    <div class="col-lg-4">
                      <label for class="col-form-label">Provinsi</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="text"
                        v-model="form.province"
                        class="form-control"
                        value
                        placeholder="Provinsi..."
                        autocomplete="off"
                      >
                    </div>
                  </div>
                  <div class="row g-0 g-lg-3 align-items-center mb-3">
                    <div class="col-lg-4">
                      <label for class="col-form-label">Kode Pos</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="text"
                        v-model="form.postal_code"
                        class="form-control"
                        value
                        placeholder="Kode Pos..."
                        autocomplete="off"
                      >
                    </div>
                  </div>

                  <hr class="border-0 pt-1 bg-dark rounded my-4">

                  <div class="row g-0 g-lg-3 align-items-center mb-3">
                    <div class="col-lg-4">
                      <label for class="col-form-label">Email</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="email"
                        v-model="form.email"
                        class="form-control"
                        value
                        placeholder="Alamat Email..."
                        autocomplete="off"
                      >
                    </div>
                  </div>
                  <div class="row g-0 g-lg-3 align-items-center mb-3">
                    <div class="col-lg-4">
                      <label for class="col-form-label">Email CC</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="email"
                        v-model="form.email_cc"
                        class="form-control"
                        value
                        placeholder="Alamat Email CC..."
                        autocomplete="off"
                      >
                    </div>
                  </div>
                  <div class="row g-0 g-lg-3 align-items-center mb-3">
                    <div class="col-lg-4">
                      <label for class="col-form-label">Email BCC</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="email"
                        v-model="form.email_bcc"
                        class="form-control"
                        value
                        placeholder="Alamat Email BCC..."
                        autocomplete="off"
                      >
                    </div>
                  </div>
                  <div class="row g-0 g-lg-3 align-items-center mb-3">
                    <div class="col-lg-4">
                      <label for class="col-form-label">Nomor Telepon</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="text"
                        v-model="form.phone_number"
                        class="form-control"
                        value
                        placeholder="Nomor Telepon..."
                        min="0"
                        autocomplete="off"
                      >
                    </div>
                  </div>

                  <button type="submit" class="btn btn-primary mt-4 liveToastBtn">Simpan</button>
                </form>
              </div>

              <div class="col-sm-5 col-lg-3 col-xxl-2 order-1 order-sm-2">
                <div class="mb-2">
                  <img
                    v-if="preview != ''"
                    :src="preview"
                    alt="preview"
                    class="shadow-sm img-fluid rounded-3 border border-5"
                  >
                  <img
                    v-else-if="preview == ''"
                    src="../assets/images/placeholder-thumb.png"
                    class="shadow-sm img-fluid rounded-3 border border-5"
                    alt="no-img"
                  >
                  <img v-else :src="preview" alt="preview" class="img-fluid rounded-3">
                </div>
                <button
                  @click="triggerFileInput"
                  class="btn btn-sm btn-success rounded"
                >Upload Image Logo</button>
                <input type="file" @change="onFileChange" ref="fileInput" style="display: none">

                <br>
                <br>
                <br>

                <div class="mb-2">
                  <img
                    v-if="previewFav != ''"
                    :src="previewFav"
                    alt="preview"
                    class="shadow-sm img-fluid rounded-3 border border-5"
                    width="100"
                  >
                  <img
                    v-else-if="previewFav == ''"
                    src="../assets/images/placeholder-thumb.png"
                    class="shadow-sm img-fluid rounded-3 border border-5"
                    alt="no-img"
                    width="100"
                  >
                </div>
                <button
                  @click="triggerFileInputFav"
                  class="btn btn-sm btn-success rounded"
                >Upload Image Favicon</button>
                <input type="file" @change="onFileChangeFav" ref="fileInputFav" style="display: none">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import { mapGetters } from 'vuex'
import Highlight from '../components/Highlight.vue'
import EmptyPlaceholder from '../components/EmptyPlaceholder.vue'
import config from '../config'

export default {
	components: {
		Highlight,
		EmptyPlaceholder
	},
	data() {
		return {
			token: localStorage.getItem('token'),
			form: {
				// id: '',
				site_title: '',
				site_description: '',
				address: '',
				city: '',
				province: '',
				postal_code: '',
				country: 'ID',
				email: '',
				email_cc: '',
				email_bcc: '',
				logo: '',
				phone_number: ''
			},
			formTitle: 'Add New',
			url: 'users/add',
			method: 'post'
		}
	},
	created() {
		if (!this.token) {
			this.$router.push('/login')
		}
		// this.getDataList()
		// this.$store.commit("settings/setMenuActive", "dc-location");
		// this.$store.dispatch("auth/getNotif");
		this.$store
			.dispatch('location/getDataPayload', {
				url: `settings/1`
			})
			.then((res) => {
				this.form = res.payload
			})
		this.$store.dispatch('location/getDataThird', {
			url: `datasheet/provinces`
		})
	},
	computed: {
		...mapGetters({
			dataConfig: 'location/getDataPayload',
			provinceList: 'location/getDataThird',
			cityList: 'location/getDataPayload'
		}),
		preview: {
			// getter
			get() {
				let url = ''
				if (this.dataConfig) {
					if (this.dataConfig.logo === null || this.dataConfig.logo === 'null' || this.dataConfig.logo === undefined || this.dataConfig.logo === 'undefined' || this.dataConfig.logo === '') {
					} else {
						url = config('api.baseUrl') + 'storage/uploads/' + this.dataConfig.logo
					}
				} else {
				}
				return url
			},
			set(value) {
				this.dataConfig.logo = value
			}
		},
		previewFav: {
			// getter
			get() {
				let url = ''
				if (this.dataConfig) {
					if (this.dataConfig.favicon === null || this.dataConfig.favicon === 'null' || this.dataConfig.favicon === undefined || this.dataConfig.favicon === 'undefined' || this.dataConfig.favicon === '') {
					} else {
						url = config('api.baseUrl') + 'storage/uploads/' + this.dataConfig.favicon
					}
				} else {
				}
				return url
			},
			set(value) {
				this.dataConfig.favicon = value
			}
		}
	},
	methods: {
		triggerFileInput() {
			this.$refs.fileInput.click() // klik input file tersembunyi
		},
		// upload khusus update user
		onFileChange(e) {
			const file = e.target.files[0]
			if (file) {
				// this.file = file
				// this.preview = URL.createObjectURL(file) // buat preview gambar

				let formData = new FormData()
				formData.append('image', file)
				this.$store.dispatch('location/upload', formData).then((res) => {
					// this.storeData(res.filename)
					console.log('res dari api set img logo==>', res)
					console.log('res.filename==>', res.filename)
					this.form.logo = res.filename
					this.preview = res.filename
					// this.form.name = this.form.fullname
					this.onSubmit()
				})
			}

			// if (!this.file) {
			// 	alert('Pilih gambar dulu!')
			// 	return
			// }
		},
		triggerFileInputFav() {
			this.$refs.fileInputFav.click() // klik input file tersembunyi
		},
		onFileChangeFav(e) {
			const file = e.target.files[0]
			if (file) {
				// this.fileFav = file
				// this.preview = URL.createObjectURL(file) // buat preview gambar

				let formData = new FormData()
				formData.append('image', file)
				this.$store.dispatch('location/upload', formData).then((res) => {
					// this.storeData(res.filename)
					console.log('res dari api set img==>', res)
					this.previewFav = res.filename
					this.form.favicon = res.filename
					// this.form.name = this.form.fullname
					this.onSubmit()
				})
			}
		},
		getCity() {
			this.$store.dispatch('location/getDataPayload', {
				url: `datasheet/cities/${this.form.province}`
			})
		},
		onSubmit() {
			this.$store
				.dispatch('location/createNewRecord', {
					data: this.form,
					url: 'settings/1',
					method: 'PUT'
				})
				.then((res) => {
					console.log(res)
					let toast = this.$toasted.show(`${res.msg}`, {
						theme: 'bubble',
						position: 'top-right',
						duration: 3000
					})
				})
		}
	}
}
</script>

<style lang="scss">
.file {
	position: relative;
	overflow: hidden;
}

.input-file {
	position: absolute;
	font-size: 50px;
	opacity: 0;
	right: 0;
	top: 0;
}
</style>

